import { NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { IconComponent } from 'components/layout/icon/icon.component';
import { CredentialsDirective } from 'directives/credential.directive';
import { CredentialType } from 'enums/CredentialType';
import { HubAction } from 'enums/HubAction';
import { MessageType } from 'enums/MessageType';
import { ProgressMessageStatus } from 'enums/ProgressMessageStatus';
import { ProgressMessageModel, PushMessageModel } from 'models/PushMessage';
import { CustomDatePipe } from 'pipes/custom-date.pipe';
import { CompanyDataProviderFactory, DataProviderInstance } from 'services/company-data-provider';
import { CredentialRequired } from 'services/credential.service';
import { PushService } from 'services/push.service';
import { WorkspaceService } from 'services/workspace.service';

@Component({
	selector: 'coder-debug',
	templateUrl: './coder-debug.component.html',
	styleUrls: ['./coder-debug.component.scss'],
	providers: [WorkspaceService, CompanyDataProviderFactory],
	imports: [CredentialsDirective, NgClass, IconComponent, CustomDatePipe]
})
@CredentialRequired(CredentialType.AccessDebugViews)
export class CoderDebugComponent {
	active = false;
	debugUser = CredentialType.AccessDebugViews;
	timeLeft = new Map<DataProviderInstance, number>();
	hubMessages: { message: (PushMessageModel | ProgressMessageModel), timestamp: Date }[] = [];
	constructor(private readonly companyDataProviderFactory: CompanyDataProviderFactory, private readonly pushService: PushService) {
		setInterval(() => {
			for (let instance of this.companyDataProviderFactory.getActiveProviders()) {
				this.timeLeft.set(instance, Math.max(0, Math.round(instance.getTimeLeft() / 1000)));
			}
		}, 1000);

		pushService.connection.on('NewPushMessage', (result: PushMessageModel) => {
			this.hubMessages.push({ message: Object.assign(new PushMessageModel(), result), timestamp: new Date() });
		});
		pushService.connection.on('NewProgressMessage', (result: ProgressMessageModel) => {
			this.hubMessages.push({ message: Object.assign(new ProgressMessageModel(), result), timestamp: new Date() });
		});
	}

	activateCoderDebugger() {
		this.active = !this.active;
		if (!this.active) return;
	}

	get signalrConnectionState() {
		return this.pushService.connection.state;
	}

	get companyProviders() {
		return this.companyDataProviderFactory.getActiveProviders();
	}

	displayProvider(provider: DataProviderInstance) {
		console.log(provider);
	}
	displayMessage(message: PushMessageModel | ProgressMessageModel) {
		console.log(message);
	}
	getMessageHeader(message: PushMessageModel | ProgressMessageModel) {
		if (message instanceof PushMessageModel) {
			return `Push: Id: ${message.id.substr(0, 8)}, Type: ${MessageType[message.messageType]}, ${HubAction[message.hubMessage.action]}`;
		} else {
			return `Progress: ReferenceId: ${message.referenceId}, Status: ${ProgressMessageStatus[message.status]}, Progression: ${message.processed} of ${message.total}`;
		}
	}
}
